<template>
  <div>
  <div id="yodahCheckout" v-show="!paymentInProgress">
    <div id="isPaid" v-if="isPaid" class="">
      <h2>ORDER CONFIRMATION</h2>
      <p class="lead">Thank you for your order.</p>
      <p class="lead">Your payment has been successful and you will receive a confirmation email shortly.</p>
      <p>If you have any questions about your order, please <a href="/contact" title="Contact Us" target="_blank">contact us</a> quoting order number: {{ orderId }}</p>
    </div>
    <div v-else-if="payPalOrderDetails">
      <h2>COMPLETE YOUR ORDER</h2>
      <p class="lead">PayPal has authorized your payment and confirmed your details as;</p>
      <p>{{ payPalOrderDetails.payer.name.given_name + ' ' + payPalOrderDetails.payer.name.surname + ' - ' + payPalOrderDetails.payer.email_address }}</p>
      <p>Deliver to:</p>
      <p>
        {{ payPalOrderDetails.purchase_units[0].shipping.name.full_name }}<br v-if="payPalOrderDetails.purchase_units[0].shipping.name.full_name">
        {{ payPalOrderDetails.purchase_units[0].shipping.address.address_line_1 }}<br v-if="payPalOrderDetails.purchase_units[0].shipping.address.address_line_1">
        {{ payPalOrderDetails.purchase_units[0].shipping.address.address_line_2 }}<br v-if="payPalOrderDetails.purchase_units[0].shipping.address.address_line_2">
        {{ payPalOrderDetails.purchase_units[0].shipping.address.admin_area_2 }}<br v-if="payPalOrderDetails.purchase_units[0].shipping.address.admin_area_2">
        {{ payPalOrderDetails.purchase_units[0].shipping.address.admin_area_1 }}<br v-if="payPalOrderDetails.purchase_units[0].shipping.address.admin_area_1">
        {{ payPalOrderDetails.purchase_units[0].shipping.address.postal_code + ' ' + payPalOrderDetails.purchase_units[0].shipping.address.country_code }}
      </p>
      <p>To complete the order please provide your phone number and accept our terms and conditions:</p>
      <form name="payPalForm" id="payPalForm" @submit.prevent="completePayPalOrder">
        <text-input class="flex-50" label="Tel." v-model="telMobile" name="tel" type="text" placeholder="Tel." required=true v-validate="'required|max:14'" :vErrors="errors" autocomplete="tel"></text-input>
        <label for="accept">
          <input id="accept" type="checkbox" value="0" v-model="acceptPayPalTerms">
          <span v-html="termsText" class="terms"></span>
          <div>
            <button class="complete-order btn btn-lg btn-primary" type="submit" :disabled="!acceptPayPalTerms || submitting"><span v-if="!submitting"><i class="fa fa-check"></i> Complete Order</span><span v-else>Processing... <i class="fa fa-spinner fa-pulse"></i></span></button>
          </div>
          <div v-if="paypalErrorMsg" class="help has-error">{{paypalErrorMsg}}</div>
        </label>
      </form>
    </div>
    <div v-else>
<!--    <vue-recaptcha v-else class="">-->
      <hr v-if="ppClientId">
      <div id="paypal-button-container"></div>

      <div data-pp-message data-pp-style-layout="text" data-pp-style-logo-type="inline" data-pp-style-text-color="black" :data-pp-amount="basketValues.gross"></div>

      <!--    </vue-recaptcha>-->
      <div v-if="paypalErrorMsg" class="help has-error">{{paypalErrorMsg}}</div>
      <div v-if="ppClientId" class="divider m-t-30">
        <h3 class="text-center or">Or</h3>
      </div>
      <h3 class="checkout-text text-center">Checkout securely below</h3>
      <img v-if="cardPaymentOn" src="/wp-content/plugins/yodah/images/visa-mastercard-amex-30.png" class="center-block"/>
      <hr>
      <form name="guestCheckoutForm" id="guestCheckoutForm" @submit.prevent="submitOrder">
        <h2>Your details</h2>
        <div class="yodah-flex-container y-checkout-group">
          <text-input class="flex-20" label="Title" v-model="title" name="title" type="text" placeholder="Title (optional)" v-validate="'alpha'" :vErrors="errors" autocomplete="honorific-prefix" v-on:blur="onCheckoutFormUpdated"></text-input>
          <text-input class="flex-40" label="First Name" v-model="firstName" name="firstName" type="text" placeholder="First Name" required=true v-validate="'required|alpha|min:3'" :vErrors="errors" autcomplete="given-name" v-on:blur="onCheckoutFormUpdated"></text-input>
          <text-input class="flex-40" label="Last Name" v-model="lastName" name="lastName" type="text" placeholder="Last Name" required=true v-validate="'required|alpha|min:3'" :vErrors="errors" autocomplete="family-name" v-on:blur="onCheckoutFormUpdated"></text-input>
        </div>
        <div class="yodah-flex-container y-checkout-group">
          <text-input class="flex-50" label="Email" v-model="email" name="email" type="text" placeholder="Email" required=true v-validate="'required|email'" :vErrors="errors" autocomplete="email" v-on:blur="onCheckoutFormUpdated"></text-input>
          <text-input class="flex-50" label="Tel." v-model="telMobile" name="tel" type="text" placeholder="Tel." required=true v-validate="'required|max:14'" :vErrors="errors" autocomplete="tel" v-on:blur="onCheckoutFormUpdated"></text-input>
        </div>
        <div class="yodah-flex-container y-checkout-group">
          <text-input class="flex-50" label="Company" v-model="company" name="company" type="text" placeholder="Company Name (optional)" v-validate="" :vErrors="errors" v-on:blur="onCheckoutFormUpdated"></text-input>
          <text-input class="flex-50" label="VAT No." v-model="vat" name="vat" type="text" placeholder="VAT Number (optional) e.g: GB012345678" v-validate="" :vErrors="errors" v-on:blur="onCheckoutFormUpdated"></text-input>
        </div>
        <hr>
        <h2 class="">Delivery address</h2>
        <div class="yodah-flex-container y-checkout-group m-b-10">
          <div class="flex-100">
            <div class="form-group required">
              <label for="country">Country<sup>*</sup></label>
              <Select2 id="country"
                       name="country"
                       v-model="daCountry"
                       :settings="{placeholder: 'Country*'}"
                       :options="countries"
                       v-validate="'required'"
                       autocomplete="country" >
              </Select2>
              <p v-show="errors.has('country')" class="control has-icon has-icon-right"><i class="fa fa-warning" style="color: #E74C3C;"></i> <span class="help has-error"> {{ errors.first('country') }}</span></p>
            </div>
          </div>
        </div>
        <div class="yodah-flex-container y-checkout-group">
          <div class="flex-100">
            <div class="form-group required">
              <label for="address">Address<sup class="required">*</sup></label>
              <VueGoogleAutoComplete
                  id="address"
                  ref="deliveryAdd"
                  key="deliveryAdd"
                  v-model="daStreet"
                  name="street"
                  classname="form-control"
                  placeholder="Address"
                  v-on:placechanged="autoDeliveryAddress"
                  :country="['GB']"
                  onfocus="this.setAttribute('autocomplete', 'none')"
                  v-on:inputChange="setAddress('delivery', $event)"
              >
              </VueGoogleAutoComplete>
              <p v-show="daStreetErrors" class="control has-icon has-icon-right"><i class="fa fa-warning" style="color: #E74C3C;"></i> <span class="help has-error"> {{ daStreetErrors }}</span></p>
            </div>
          </div> 
        </div>
        <!--        <div class="yodah-flex-container y-checkout-group">-->
        <!--          <text-input class="flex-30" label="Building Name/No." v-model="deliveryAddress['building_num']" name="building_num" type="text" placeholder="Building Name/No." required=true v-validate="'required'" :vErrors="errors" autocomplete="address-line1"></text-input>-->
        <!--          <text-input class="flex-70" label="Street" v-model="deliveryAddress['street']" name="street" type="text" placeholder="Brasenose Road" required=true v-validate="'required'" :vErrors="errors" autocomplete="address-line2"></text-input>-->
        <!--        </div>-->
        <div class="yodah-flex-container y-checkout-group">
          <text-input class="flex-100" label="Apartment Number/Unit/Building" v-model="daStreet2" name="building" type="text" placeholder="Apartment Number/Unit/Building (optional)" v-validate="''" :vErrors="errors" autocomplete="none" v-on:blur="onCheckoutFormUpdated"></text-input>
        </div>
        <div class="yodah-flex-container y-checkout-group">
          <text-input class="flex-50" label="Town/City" v-model="daCity" name="city" type="text" placeholder="Town/City" required=true v-validate="'required|alpha_spaces'" :vErrors="errors" autocomplete="address-level2" v-on:blur="onCheckoutFormUpdated"></text-input>
          <text-input class="flex-50" label="Post Code" v-model="daPostCode" name="post_code" type="text" placeholder="Post Code" required=true v-validate="'required'" :vErrors="errors" autocomplete="postal-code" v-on:blur="onCheckoutFormUpdated"></text-input>
        </div>

        <div class="yodah-flex-container y-checkout-group">
          <text-input class="flex-50" label="Delivery Contact" v-model="daContactName" name="contact" type="text" placeholder="Delivery Contact" v-validate="'alpha_spaces'" :vErrors="errors" autocomplete="none" v-on:blur="onCheckoutFormUpdated"></text-input>
          <text-input class="flex-50" label="Delivery Contact Tel." v-model="daContactTel" name="contact_tel" type="text" placeholder="Delivery Contact Tel." v-validate="'alpha_dash'" :vErrors="errors" autocomplete="none" v-on:blur="onCheckoutFormUpdated"></text-input>
        </div>
        <div class="yodah-flex-container y-checkout-group">
          <div class="flex-100">
            <div class="form-group">
              <label for="notes">Delivery Instructions</label>
              <textarea id="notes" rows="4" name="notes"
                        v-model="daNotes"
                        class="form-control input"
                        type="text"
                        placeholder="Delivery Instructions (optional)"
                        data-vv-as="address notes"
                        autocomplete="shipping notes"
                        v-on:blur="onCheckoutFormUpdated"></textarea>
              <p class="control has-icon has-icon-right">
                <i v-show="errors[0]" class="fa fa-warning"></i>
                <span v-show="errors[0]"
                      class="help has-error">{{ errors[0] }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="m-t-30">
          <hr>
          <h2 class="">Billing address</h2>
          <div class="checkbox">
            <label for="same">
              <input id="same" type="checkbox" value="1" v-model="sameAddress" v-on:change="onCheckoutFormUpdated">
              Same as delivery address
            </label>
          </div>
        </div>
        <div v-if="!sameAddress">
          <div class="yodah-flex-container y-checkout-group m-b-10">
            <div class="flex-100">
              <div class="form-group required">
                <label for="billing-country">Country<sup>*</sup></label>
                <Select2 id="billing-country"
                         name="billing_country"
                         v-model="baCountry"
                         :settings="{placeholder: 'Country'}"
                         :options="countries"
                         v-validate="'required'"
                         autocomplete="country-name">
                </Select2>
                <p v-show="errors.has('billing_country')" class="control has-icon has-icon-right"><i class="fa fa-warning" style="color: #E74C3C;"></i> <span class="help has-error"> {{ errors.first('billing_country') }}</span></p>
              </div>
            </div>
          </div>
          <div class="yodah-flex-container y-checkout-group">
            <div class="flex-100">
              <div class="form-group required">
                <label for="billingAddress">Address<sup class="required">*</sup></label>
                <VueGoogleAutoComplete
                    id="billingAddress"
                    ref="billingAdd"
                    v-model="baStreet"
                    name="billing street"
                    classname="form-control"
                    placeholder="Address"
                    v-on:placechanged="autoBillingAddress"
                    :country="[billingAddress.country]"
                    onfocus="this.setAttribute('autocomplete', 'none')"
                    v-on:inputChange="setAddress('billing', $event)"
                >
                </VueGoogleAutoComplete>
                <p v-show="baStreetErrors" class="control has-icon has-icon-right"><i class="fa fa-warning" style="color: #E74C3C;"></i> <span class="help has-error"> {{ baStreetErrors }}</span></p>
              </div>
            </div>
          </div>
          <!--          <div class="yodah-flex-container y-checkout-group">-->
          <!--            <text-input class="flex-30" label="Building Name/No." v-model="billingAddress['building_num']" name="billing_building_num" type="text" placeholder="Building Name/Number" required=true v-validate="'required'" :vErrors="errors" autocomplete="address-line1"></text-input>-->
          <!--            <text-input class="flex-70" label="Street" v-model="billingAddress['street']" name="billing_street" type="text" placeholder="Street" required=true v-validate="'required'" :vErrors="errors" autocomplete="address-line2"></text-input>-->
          <!--          </div>-->
          <div class="yodah-flex-container y-checkout-group">
            <text-input class="flex-100" label="Apartment Number/Unit/Building" v-model="baStreet2" name="billing_street2" type="text" placeholder="Apartment Number/Unit/Building (optional)" v-validate="''" :vErrors="errors" autocomplete="none" v-on:blur="onCheckoutFormUpdated"></text-input>
          </div>
          <div class="yodah-flex-container y-checkout-group">
            <text-input class="flex-50" label="Town/City" v-model="baCity" name="billing_city" type="text" placeholder="Town/City" required=true v-validate="'required|alpha_spaces'" :vErrors="errors" autocomplete="address-level2" v-on:blur="onCheckoutFormUpdated"></text-input>
            <text-input class="flex-50" label="Post Code" v-model="baPostCode" name="billing_post_code" type="text" placeholder="Post Code" required=true v-validate="'required'" :vErrors="errors" autocomplete="postal-code" v-on:blur="onCheckoutFormUpdated"></text-input>
          </div>

          <!--          <div class="yodah-flex-container y-checkout-group">-->
          <!--            <text-input class="flex-50" label="Contact Name" v-model="billingAddress['contact_name']" name="billing_contact_name" type="text" placeholder="Billing Contact Name" v-validate="'alpha_spaces'" :vErrors="errors" autocomplete="off"></text-input>-->
          <!--            <text-input class="flex-50" label="Contact Tel." v-model="billingAddress['contact_tel']" name="billing_contact_tel" type="text" placeholder="Billing Contact Tel." v-validate="'alpha_dash'" :vErrors="errors" autocomplete="off"></text-input>-->
          <!--          </div>-->
          <!--          <div class="yodah-flex-container y-checkout-group">-->
          <!--            <div class="flex-100">-->
          <!--              <div class="form-group">-->
          <!--                <label for="billing-notes">Delivery Instructions</label>-->
          <!--                <textarea id="billing-notes" rows="4" name="billing_notes"-->
          <!--                        v-model="billingAddress['notes']"-->
          <!--                        class="form-control input"-->
          <!--                        type="text"-->
          <!--                        placeholder="Delivery Instructions"-->
          <!--                        data-vv-as="address notes"></textarea>-->
          <!--                <p class="control has-icon has-icon-right">-->
          <!--                  <i v-show="errors[0]" class="fa fa-warning"></i>-->
          <!--                  <span v-show="errors[0]"-->
          <!--                        class="help has-error">{{ errors[0] }}</span>-->
          <!--                </p>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <hr>
        <h2>Payment</h2>
        <div class="m-t-10 checkbox">
          <label for="terms" class="required">
            <input id="terms" class="required m-t-30" type="checkbox" v-model="terms" name="terms" value="1" v-validate="'required'">
            <span v-html="termsText" class="terms"></span><sup class="required">*</sup>
          </label><br>
          <span class="help has-error" v-show="errors.has('terms')">{{ errors.first('terms') }}</span>
        </div>
        <vue-recaptcha v-if="isTruelayerOn" @verify="storeExpressOrderForPayment($event, 'truelayer')" @expired="token = null; submitDisabled = true"
                       :sitekey="recaptchaSiteKey" type="invisible" badge="bottomleft"
                       :loadRecaptchaScript="true" ref="recaptchaRef" @error="recaptchaError">
          <button type="submit" :class="{'btn btn-lg btn-cart w100 btn-primary': true, 'disabled': submitting}" :disabled="submitting || submitDisabled"
                  title="Pay Now">
            <span v-if="!truelayerSubmitting">Proceed to Secure Bank Payment <i class="dashicons dashicons-arrow-right-alt"></i></span>
            <span v-else>Loading payment... <i class="fa fa-spinner fa-pulse"></i></span>
          </button>
          <p class="help-block m-b-30">Click the button above to setup a fast, safe and secure bank payment to us for your goods. Powered and secured by <a href="https://truelayer.com">Truelayer <i class="fa fa-external-link"/></a>.</p>
        </vue-recaptcha>
<!--        <button @click="storeExpressOrder" :class="{'btn btn-lg btn-cart w100 m-b-30 btn-primary': true, 'disabled': submitting}" title="Pay Now">-->
<!--        </button>-->
        <div v-if="cardPaymentOn">
          <vue-recaptcha v-if="cardPaymentType === 'ycp' && !card" @verify="submitOrder" @expired="token = null; submitDisabled = true"
                         :sitekey="recaptchaSiteKey" type="invisible" badge="bottomleft"
                         :loadRecaptchaScript="true" ref="recaptchaRef" @error="recaptchaError">
            <button id="pay-now" type="submit" :class="{'btn btn-lg btn-cart w100 btn-primary': true, 'disabled': submitting}" :disabled="submitting || submitDisabled"
                    title="Pay Now">
              <span v-if="!submitting">Proceed to Secure Card Payment <i class="dashicons dashicons-arrow-right-alt"></i></span>
              <span v-else>Loading payment... <i class="fa fa-spinner fa-pulse"></i></span>
            </button>
          </vue-recaptcha>
          <div class="card-root">
            <div class="card-main">
              <form id="payment-form" :class="{'hidden' : cardPaymentType === 'yma' || !card, 'card-payment-form' : true}" class="m-b-10" @submit.prevent="doCardPayment()">
                <h3>Enter card details</h3>
                <div class="card-combo-inputs-row">
                  <div class="card-input card-card-element" id="card-element"></div>
                </div>
                <div class="card-field-error" id="card-errors" role="alert"></div>
                <button id="submit">
                  <div class="spinner hidden" id="spinner"></div>
                  <span id="button-text">Pay</span><span id="order-amount"></span>
                </button>
              </form>
              <div class="card-result hidden">
                <p style="color:#1ab394;font-size: 21px;">
                  <span><i class="fa fa-check"></i> Payment completed</span>
                </p>
              </div>
            </div>
          </div>
          <vue-recaptcha v-if="cardPaymentType === 'yma'" @verify="storeExpressOrderForPayment($event, 'worldpay')" @expired="token = null; submitDisabled = true"
                         :sitekey="recaptchaSiteKey" type="invisible" badge="bottomleft"
                         :loadRecaptchaScript="true" ref="recaptchaRef" @error="recaptchaError">
            <button type="submit" :class="{'btn btn-lg btn-cart w100 btn-primary': true, 'disabled': submitting}" :disabled="submitting || submitDisabled"
                    title="Pay Now">
              <span v-if="!worldpaySubmitting">Proceed to Secure Card Payment <i class="dashicons dashicons-arrow-right-alt"></i></span>
              <span v-else>Loading payment... <i class="fa fa-spinner fa-pulse"></i></span>
            </button>
          </vue-recaptcha>
          <p class="help-block">All transactions are secure and encrypted. We accept: <img class="" src="/wp-content/plugins/yodah/images/visa-mastercard-amex-30.png" title="Secure Card Payment" /></p>
        </div>
      </form>
      <!--need to comment the below-->
      <!--      <form id="card-form" :class="{'hidden' : !orderId, 'sr-payment-form' : true}" @submit.prevent="doCardPayment()">-->
      <!--        <div id="card-element"></div>-->
      <!--        <button type="submit">Pay</button>-->
      <!--      </form>-->
      <!--      <div class="sr-result hidden"><pre></pre></div>-->
      <!--      <div class="sr-field-error"></div>-->
      <!--      end of commentig  -->

    </div>
  </div>
    <div v-show="paymentInProgress" id="yodah-card-payment-iframe-block">
      <button class="btn btn-info btn-sm" title="Cancel payment and return to checkout" @click="cancelPayment" >
        <span class="dashicons dashicons-arrow-left-alt2 iframe-close"></span> Cancel Payment
      </button>
      <div v-if="!iframeLoaded">Loading payment... <i class="fa fa-spinner fa-pulse"></i></div>
    </div>
<!--    <div v-show="paymentInProgress" id="yodah-card-payment-iframe-block">-->
<!--      <button class="btn btn-danger btn-sm" title="Cancel payment and return to checkout" @click="paymentInProgress = !paymentInProgress; worldpaySubmitting = false; submitting = false" ><i v-show="iframeLoaded" class="fa fa-times iframe-close"></i> Cancel Payment</button>-->
<!--      &lt;!&ndash; Iframe loaded &ndash;&gt;-->
<!--    </div>-->
  </div>
</template>
<script>
import Countries from './countries';
import VueRecaptcha from 'vue-recaptcha';
import TextInput from './text-input.vue';
import Select2 from 'v-select2-component';
import VueGoogleAutoComplete from 'vue-google-autocomplete';
import axios from "axios";
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import {mapState} from 'vuex';
import { loadScript } from "@paypal/paypal-js";

export default {
  el: '#checkout',
  components: {
    VueRecaptcha,
    TextInput,
    Select2,
    VueGoogleAutoComplete,
    StripeElementCard
  },
  data() {
    return {
      acceptPayPalTerms: false,
      paymentType: null,
      truelayerError: null,
      countries: Countries,
      card: null,
      cardPaymentOn: parseInt(jQuery('#yodah-card-payment').val()),
      debounceTimer: null,
      paymentInProgress: false,
      iframeLoaded: false,
      elements: null,
      isPaid: false,
      gaBasket: [],
      ga4Basket: [],
      payButton: null,
      paymentProvider: '',
      paypalErrorMsg: '',
      ppClientId: jQuery('#ppClientId').val(),
      payPalOrderData: '',
      payPalOrderDetails: '',
      publishableKey: 'pk_test_51ILpdeC5DLbxQsl0zS2qNAOxCMm3U9QDqLTXwdVyCXEoPBXrEpAImistj4Q33lnWpcQ7ouZJx3Jz39pgEOIrFNNo00eSN3fB9G',
      recaptchaSiteKey: jQuery('#recaptcha').val(),
      scrollOffset: jQuery('#scroll-offset').val(),
      showCard: false,
      stripe: null,
      submitting: false,
      truelayerSubmitting: false,
      worldpaySubmitting: false,
      submitDisabled: true,
      terms: false,
      termsText: jQuery('#yodah-terms').val(),
      token: null,
      yodahURL: jQuery('#yodah-url').val(),
      cardPaymentType: jQuery('#yodah-card-payment-type').val(),
      isTruelayerOn: jQuery('#yodah-truelayer').val() === 'On',
      discountCodeState: '',
    }
  },
  beforeMount() {
   this.$store.dispatch('calculateBasketValues', "load");
  },
  computed: {
    ...mapState(["basket", "basketValues", "basketId", "discountCode", "discountPercentage", "discountApplied", "discountMsg", "discountIntroducer", "deliveryAddress", "billingAddress", "publicKey", "accountId", "paymentIntent" ]),
    sameAddress: {
      get() {
        return this.$store.state.sameAddress;
      },
      set(value) {
        this.$store.commit('updateSameAddress', value);
      },
    },
    orderId: {
      get() {
        return this.$store.state.orderId;
      },
      set(value) {
        this.$store.commit('updateOrderId', value);
      },
    },
    daCountry: {
      get() {
        return this.$store.state.deliveryAddress.country;
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'country', value: value});
      },
    },
    daStreetErrors: {
      get() {
        return this.$store.state.deliveryAddress.streetErrors;
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'streetErrors', value: value});
      },
    },
    daStreet: {
      get() {
        return this.$store.state.deliveryAddress.street;
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'street', value: value});
      },
    },
    daStreet2: {
      get() {
        return this.$store.state.deliveryAddress.street2;
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'street2', value: value});
      },
    },
    daCity: {
      get() {
        return this.$store.state.deliveryAddress.city;
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'city', value: value});
      },
    },
    daPostCode: {
      get() {
        return this.$store.state.deliveryAddress.post_code;
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'post_code', value: value});
      },
    },
    daContactName: {
      get() {
        return this.$store.state.deliveryAddress.contact_name;
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'contact_name', value: value});
      },
    },
    daContactTel: {
      get() {
        return this.$store.state.deliveryAddress.contact_tel
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'contact_tel', value: value});
      },
    },
    daNotes: {
      get() {
        return this.$store.state.deliveryAddress.notes
      },
      set(value) {
        this.$store.commit('updateDeliveryAddress', {key: 'notes', value: value});
      },
    },
    baStreetErrors: {
      get() {
        return this.$store.state.billingAddress.streetErrors
      },
      set(value) {
        this.$store.commit('updateBillingAddress', {key: 'streetErrors', value: value});
      },
    },
    baCountry: {
      get() {
        return this.$store.state.billingAddress.country
      },
      set(value) {
        this.$store.commit('updateBillingAddress', {key: 'country', value: value});
      },
    },
    baStreet: {
      get() {
        return this.$store.state.billingAddress.street
      },
      set(value) {
        this.$store.commit('updateBillingAddress', {key: 'street', value: value});
      },
    },
    baStreet2: {
      get() {
        return this.$store.state.billingAddress.street2
      },
      set(value) {
        this.$store.commit('updateBillingAddress', {key: 'street2', value: value});
      },
    },
    baCity: {
      get() {
        return this.$store.state.billingAddress.city
      },
      set(value) {
        this.$store.commit('updateBillingAddress', {key: 'city', value: value});
      },
    },
    baPostCode: {
      get() {
        return this.$store.state.billingAddress.post_code
      },
      set(value) {
        this.$store.commit('updateBillingAddress', {key: 'post_code', value: value});
      },
    },
    firstName: {
      get() {
        return this.$store.state.customer.firstName;
      },
      set(value) {
        this.$store.commit('updateCustomer', {key: 'firstName', value: value});
      },
    },
    title: {
      get() {
        return this.$store.state.customer.title;
      },
      set(value) {
        this.$store.commit('updateCustomer', {key: 'title', value: value});
      },
    },
    lastName: {
      get() {
        return this.$store.state.customer.lastName;
      },
      set(value) {
        this.$store.commit('updateCustomer', {key: 'lastName', value: value});
      },
    },
    email: {
      get() {
        return this.$store.state.customer.email;
      },
      set(value) {
        this.$store.commit('updateCustomer', {key: 'email', value: value});
      },
    },
    company: {
      get() {
        return this.$store.state.customer.company;
      },
      set(value) {
        this.$store.commit('updateCustomer', {key: 'company', value: value});
      },
    },
    vat: {
      get() {
        return this.$store.state.customer.vat;
      },
      set(value) {
        this.$store.commit('updateCustomer', {key: 'vat', value: value});
      },
    },
    telMobile: {
      get() {
        return this.$store.state.customer.telMobile;
      },
      set(value) {
        this.$store.commit('updateCustomer', {key: 'telMobile', value: value});
      },
    },
    localId: {
      get() {
        return this.$store.state.localId;
      },
      set(value) {
        this.$store.commit('updateLocalId', value);
      },
    },

  },
  methods: {
    // to stop multiple checkoutleads being generated quickly
    async onCheckoutFormUpdated() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.checkoutLead()
      }, 1000); // 300ms delay
    },

    // check to see if email is known bot, e.g. John Smith. If so, then ignore
    // returns true if it's on the list
    async isBot() {
      // remember to add them as lower case to ensure match
      // update botlist include any storebotmail.joonix.net emails

      const botList = [

          'johnsmith001@storebotmail.joonix.net',
          'johnsmith002@storebotmail.joonix.net',
          'johnsmith003@storebotmail.joonix.net',
          'johnsmith004@storebotmail.joonix.net',
          'johnsmith005@storebotmail.joonix.net',
          'johnsmith006@storebotmail.joonix.net',
          'johnsmith007@storebotmail.joonix.net',
          'johnsmith008@storebotmail.joonix.net',
          'johnsmith009@storebotmail.joonix.net',
          'johnsmith010@storebotmail.joonix.net',
          'johnsmithstore.91@gmail.com'
      ]
      // function to check if email is in botList array
      return botList.includes(this.email.toLowerCase());
    },

    // used to save form progress in local DB
    // it is run whenever a field in the form is blur
    async checkoutLead() {
      // only submit if we have identifiable info (i.e. email or tel)
      if(!this.email && !this.telMobile || await this.isBot()) {
        return
      }
      // need to check if field has value and then validate it if it does or maybe just check to see if validation has errors?
      if(this.errors.items.length > 0) {
        return
      }

      let products = this.basket.map((item) => {
        return {
          sku: item.sku,
          count: item.quantity,
          sales_price: item.itemPrice,
          description: item.desc,
        }
      });
      let form_data = new FormData;
      form_data.append('action', 'yodah_checkout_lead');
      form_data.append('localId', this.localId);
      form_data.append('orderId', this.orderId);
      form_data.append('email', this.email);
      form_data.append('first_name', this.firstName);
      form_data.append('last_name', this.lastName);
      form_data.append('phone', this.telMobile);
      form_data.append('company', this.company);
      form_data.append('vat', this.vat);
      form_data.append('billing_address', JSON.stringify(this.billingAddress));
      form_data.append('shipping_address', JSON.stringify(this.deliveryAddress));
      form_data.append('basket', JSON.stringify(this.basket));
      form_data.append('basket_values', JSON.stringify(this.basketValues));
      // if(this.basketValues.discount > 0){
      form_data.append('discount_code', JSON.stringify(this.discountCode));
      form_data.append('products', JSON.stringify(products));
      form_data.append('ecommerce_website_id', document.domain);
      form_data.append('carriage', this.basketValues.shipping);
      form_data.append('use_same_address', this.sameAddress);
      form_data.append('amount', this.basketValues.gross);
      // }
      await axios.post(my_ajax_object.ajax_url,
          form_data,
          this.headers
      ).then(response => {
        if(!this.localId) {
            // should commit this to vuex
          this.$store.commit('setLocalId', response.data.data.localId);
        }
        if(!this.orderId) {
          // this.orderId is in vuex using get/set
          this.orderId = response.data.data.yodahId;
        }
      });
    },

    // not sure this is called by any other functions (that are not already commented..??)
    // orderResponse(response) {
    //   if (response.data.status == "CARD_ENROLLED") {
    //     // show iframe for 3ds
    //     $('#npAuthFrm').html('')
    //     $('<iframe>', {
    //       src: 'about:blank',
    //       id: '3dsAuth',
    //       frameborder: 0,
    //       width: "100%",
    //       height: "450"
    //     }).appendTo('#npAuthFrm');
    //     document.body.style.cursor = 'auto';
    //     var iframe = $('#3dsAuth');
    //     iframe[0].contentDocument.write(response.data.html);
    //     iframe[0].contentWindow.document.close();
    //     //$('#npAuthFrm').html('<div style="height:450px; text-align: center; padding-top:50px;"><p class="lead">Contacting your bank for card verification.<br>Please wait (up to 30 seconds)... <i class="fa fa-spinner fa-pulse fa-lg"></i></p></div>');
    //     setTimeout(() => {
    //       $('#CheckModal').modal({backdrop: 'static', keyboard: false, show: true});
    //       this.submitting = false;
    //     }, 3000);
    //   } else {
    //     this.submitting = false;
    //     // there was a problem with the payment
    //     this.$notify({
    //       type: 'success',
    //       duration: -1,
    //       text: 'The card does not support 3DS verification.'
    //     })
    //   }
    //   this.token = false;
    // },

    // ? what does this do? which payment methods? cannot see it being called by any other function..?
    // getIsPaid() {
    //   axios.get(this.yodahURL + '/api/orders/' + this.orderId + '/paid', this.headers)
    //       .then(response => {
    //         console.log('was order paid? ', response.data);
    //         this.isPaid = response.data.data.is_paid;
    //       }).catch(error => {
    //     console.log(error);
    //   })
    // },

    // does not get called by anything?
    // getMonth() {
    //   this.card.exp_m = card.exp_m;
    // },

    // does not get called by anything?
    // storeToken(response) {
    //   this.token = response;
    //   this.submitDisabled = false;
    //   // console.log(this.token);
    // },

    // checks recaptcha was valid with google
    async recaptcha() {
      let response = await axios.post('/recaptcha', {'token': this.token});
      //console.log('response', response);
    },

    // run when google address is selected to auto fill address fields
    autoDeliveryAddress(address, place) {
      // this.deliveryAddress.building_num = address.street_number;
      // this.deliveryAddress.street = address.route;
      // this.deliveryAddress.street2 = address.locality;
      let postalTown = place.address_components.filter((item) => {
        return item.types[0] === 'postal_town';
      })[0];
      this.daCity = postalTown.long_name;
      this.daPostCode = address.postal_code;
      // this.deliveryAddress.country = 'GB';
      this.$refs.recaptchaRef.reset();
      this.$validator.reset();
      this.$validator.validateAll();
    },

    // run when google address is selected to auto fill address fields
    autoBillingAddress(address, place) {
      // this.billingAddress.building_num = address.street_number;
      // this.billingAddress.street = address.route;
      // this.billingAddress.street2 = address.locality;
      let postalTown = place.address_components.filter((item) => {
        return item.types[0] === 'postal_town';
      })[0];
      this.baCity = postalTown.long_name;
      this.baPosCode = address.postal_code;
      // this.billingAddress.country = 'GB';
      this.$refs.recaptchaRef.reset();
      this.$validator.reset();
      this.$validator.validateAll();
    },

    // stripe payment form
    showCardPayment() {
      this.stripe = Stripe(this.publicKey ?? this.publishableKey, {stripeAccount: this.accountId});
      let elements = this.stripe.elements();
      let style = {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };
      this.card = elements.create("card", { style: style });
      this.card.mount("#card-element");
      return {
        stripe: this.stripe,
        card: this.card,
        clientSecret: this.paymentIntent
      };
    },

    // does stripe payment
    doCardPayment() {
      /*
       * Calls stripe.handleCardPayment which creates a pop-up modal to
       * prompt the user to enter extra authentication details without leaving your page
       */
      // this.changeLoadingState(true);
      // Initiate the payment.
      // If authentication is required, handleCardPayment will automatically display a modal
      this.stripe.handleCardPayment(this.paymentIntent, this.card).then((result) => {
        if (result.error) {
          // console.log('card payment error...', result);
          // Show error to your customer
          this.showError(result.error.message);
        } else {
          // console.log('card payment successful', result);
          // The payment has been processed!
          this.isPaid = true;
          this.gaPurchaseComplete();
          this.ga4PurchaseComplete();
          this.$store.commit('emptyBasket');
          //  remove orderId, paymentIntent etc
          localStorage.removeItem("vuex");
          let el = document.getElementById("yodahCheckout");
          let y = el.getBoundingClientRect().top + window.pageYOffset - parseFloat(this.scrollOffset); //todo this is getting error
          window.scrollTo({top: y, behavior: 'smooth'});
        }
      });
    },


    /* ------- Post-payment helpers ------- */
    /* Shows a success / error message when the payment is complete */
    // orderComplete() {
    //   console.log('doing orderComplete...');
    //     this.stripe.retrievePaymentIntent(this.paymentIntent).then((result) => {
    //       console.log('get the result of the payment: ', result);
    //       let paymentIntent = result.paymentIntent;
    //       let paymentIntentJson = JSON.stringify(paymentIntent, null, 2);
    //       document.querySelector(".sr-payment-form").classList.add("hidden");
    //       document.querySelector("pre").textContent = paymentIntentJson;
    //       document.querySelector(".sr-result").classList.remove("hidden");
    //       setTimeout(function() {
    //         document.querySelector(".sr-result").classList.add("expand");
    //       }, 200);
    //       this.changeLoadingState(false);
    //     });
    //   },

    showError(errorMsgText) {
      // this.changeLoadingState(false);
      let errorMsg = document.querySelector(".card-field-error");
      errorMsg.textContent = errorMsgText;
      setTimeout(() => {
        errorMsg.textContent = "";
      }, 4000);
    },

// Show a spinner on payment submission
//     changeLoadingState(isLoading) {
//          if (isLoading) {
//           document.querySelector("button").disabled = true;
//           document.querySelector("#spinner").classList.remove("hidden");
//           document.querySelector("#button-text").classList.add("hidden");
//         } else {
//           document.querySelector("button").disabled = false;
//           document.querySelector("#spinner").classList.add("hidden");
//           document.querySelector("#button-text").classList.remove("hidden");
//         }
//       },

// Hide banner if window is too small
//       if (window.outerHeight < 600) {
//         document.querySelector(".banner").classList.add("hidden");
//       }
//     },

    // called when there is a recaptcha error. not sure it's required as recaptcha will show user message
    recaptchaError(data) {
      console.log("RecaptchaError")
      // console.log(data)
    },

    async setAddress(field, newVal) {
      if(field === 'billing') {
        this.$set(this.billingAddress, 'street', newVal.newVal);
        if (!newVal.newVal) {
          document.getElementById('billingAddress').setAttribute('autocomplete', 'street-address');
        }
      } else {
        this.$set(this.deliveryAddress, 'street', newVal.newVal);
        if (!newVal.newVal) {
          document.getElementById('address').setAttribute('autocomplete', 'street-address');
        }
      }
      await this.checkAddress()
      await this.onCheckoutFormUpdated()
      return true;
    },

    async checkAddress() {
      let response = await this.$validator.verify(this.deliveryAddress['street'], 'required', {name: 'address'});
      if(!this.sameAddress) {
        let response = await this.$validator.verify(this.billingAddress['street'], 'required', {name: 'address'});
        this.baStreetErrors = response.errors[0];
      }
      this.daStreetErrors = response.errors[0];
      return !(this.daStreetErrors || this.baStreetErrors);
    },

    async setCountry() {
      if(!this.sameAddress) {
        this.$set(this.billingAddress, 'country', document.getElementById('billing-country').value);
      }
      this.$set(this.deliveryAddress, 'country', document.getElementById('country').value);
      return true;
    },

    // run when truelayer/yma is pressed
    // creates order with Yodah and then sets up payment
    async storeExpressOrderForPayment(captcha, paymentType) {
      this.onCheckoutFormUpdated();
      // validate and check form
      this.paymentType = paymentType;
      await this.setCountry();
      let addressResult = await this.checkAddress();
      let result = await this.$validator.validateAll();
      if(!result || !addressResult){
        let el;
        let scrollToY;
        // console.log('form validation failed, please check the form')
        this.$refs.recaptchaRef.reset();
        if(!addressResult) {
          if (this.daStreetErrors) {
            el = document.getElementsByName('street');
          } else {
            el = document.getElementsByName('billing street');
          }
          scrollToY = el[0].getBoundingClientRect().top + window.pageYOffset - parseFloat(this.scrollOffset);
        } else {
          el = document.getElementsByName(this.errors.items[0].field);
          scrollToY = el[0].getBoundingClientRect().top + window.pageYOffset - parseFloat(this.scrollOffset);
        }
        return window.scrollTo({top: scrollToY, behavior: 'smooth'});
      }

      // form ok lets start payment process
      document.body.style.cursor = 'progress';
      let el = document.getElementById("yodahCheckout");
      let scrollToY = el.getBoundingClientRect().top + window.pageYOffset - parseFloat(this.scrollOffset);
      window.scrollTo({top: scrollToY, behavior: 'smooth'});
      let form_data = new FormData;
      if(paymentType === 'truelayer') {
        this.truelayerSubmitting = true;
        form_data.append('payment_method', 'truelayer');
      }
      if(paymentType === 'worldpay') {
        this.worldpaySubmitting = true;
        form_data.append('payment_method', 'worldpay');
      }
      this.paymentInProgress = true;

      this.submitDisabled = true;
      // create Yodah order if not already done so
      if(!this.orderId)
      {
        let action = 'yodah_store_express_order';
        let products = this.basket.map((item) => {
          return {
            sku: item.sku,
            count: item.quantity,
            sales_price: item.itemPrice,
            description: item.desc,
          }
        });

        form_data.append('action', action);
        form_data.append('email', this.email);
        form_data.append('title', this.title || '');
        form_data.append('first_name', this.firstName || '');
        form_data.append('last_name', this.lastName || '');
        form_data.append('phone', this.telMobile);
        form_data.append('company', this.company);
        form_data.append('vat', this.vat);

        form_data.append('carriage', this.basketValues.shipping);
        form_data.append('use_same_address', this.sameAddress);
        form_data.append('amount', this.basketValues.gross);
        form_data.append('ecommerce_website_id', document.domain);
        form_data.append('captcha', captcha);

        form_data.append('shipping_address', JSON.stringify(this.deliveryAddress));
        form_data.append('billing_address', JSON.stringify(this.billingAddress));
        form_data.append('basket', JSON.stringify(this.basket));
        form_data.append('basket_values', JSON.stringify(this.basketValues));
        form_data.append('products', JSON.stringify(products));
        form_data.append('local_id', this.localId);
        if(this.discountApplied){
          form_data.append('discount_code', JSON.stringify(this.discountCode));
          form_data.append('introducer',this.discountIntroducer);
          form_data.append('discount_value',this.basketValues.discount);
        }
        // for (const [key, value] of form_data.entries()) {
        //   // console.log(`${key}: ${value}`);
        // }
        try {
          const response = await axios.post(my_ajax_object.ajax_url,
              form_data,
              this.headers
          );

          this.$store.commit('updateOrderId', response.data.order_id);
        } catch (error) {
          // console.log('Yodah error: ', error)
          this.cancelPayment();
        }
      }

      // setup the payment
      this.gaPaymentStarted();
      // this.ga4PaymentStarted();
      // this.showCardPayment();
      if(paymentType === 'truelayer') {
        await this.paymentRedirect(this.orderId, this.basketValues.gross, 'yodah_truelayer_redirect')
      }
      if(paymentType === 'worldpay') {
        await this.paymentRedirect(this.orderId, this.basketValues.gross, 'yodah_world_pay_redirect')
      }
      this.$refs.recaptchaRef.reset();
      document.body.style.cursor = 'auto';
    },

    cancelPayment() {
      window.location.href = "/checkout";
      this.truelayerSubmitting = false;
      this.worldpaySubmitting = false;
      this.paymentInProgress = false;
      this.submitDisabled = false;
      document.body.style.cursor = 'auto';
      this.token = null;
      this.paymentType = null;
      this.submitting = false;
    },

    // does iframe for truelayer/yma
    async paymentRedirect(orderId, amount, action) {
      let form_data = new FormData;
      form_data.append('action', action);
      form_data.append('order_id', orderId);
      form_data.append('amount', amount);
      form_data.append('local_id', this.localId);
      const redirectResponse = await axios.post(my_ajax_object.ajax_url,
          form_data,
          this.headers
      );
      if(redirectResponse.data.redirect_url !== 'error') {
        // let iframe = document.createElement('iframe');
        // iframe.onload = function() { alert('myframe is loaded'); };
        // iframe.src = redirectResponse.data.redirect_url;
        // iframe.id = 'cardPaymentIframe';
        // iframe.frameborder = 0;
        // iframe.width = "100%";
        // iframe.height = 500;
        // // document.body.appendChild(iframe);
        // document.getElementById("card-payment-iframe-block").appendChild(iframe);

        let iframe = document.createElement('iframe');
        iframe.onload = () => {
          this.iframeLoaded = true;
        };
        iframe.src = redirectResponse.data.redirect_url;
        iframe.id = 'cardPaymentIframe';
        iframe.frameBorder = 0;
        iframe.width = "100%";
        iframe.height = 700;
        document.getElementById("yodah-card-payment-iframe-block").appendChild(iframe);
        // window.location.href = redirectResponse.data.redirect_url;
      }
    },

    // does stripe order
    async submitOrder(token) {
      this.onCheckoutFormUpdated();
      // trick to update select2 with autofilled data
      await this.setCountry();
      // verify fields
      // this.$validator.reset();
      let addressResult = await this.checkAddress();
      let result = await this.$validator.validateAll();
      if(!result || !addressResult){
        let el;
        let scrollToY;
        console.log('form validation failed, please check the form')
        this.$refs.recaptchaRef.reset();
        if(!addressResult) {
          if (this.daStreetErrors) {
            el = document.getElementsByName('street');
          } else {
            el = document.getElementsByName('billing street');
          }
          scrollToY = el[0].getBoundingClientRect().top + window.pageYOffset - parseFloat(this.scrollOffset);
        } else {
          el = document.getElementsByName(this.errors.items[0].field);
          scrollToY = el[0].getBoundingClientRect().top + window.pageYOffset - parseFloat(this.scrollOffset);
        }
        return window.scrollTo({top: scrollToY, behavior: 'smooth'});
      }
      console.log('form validation passed, verifying recaptcha...');
      document.body.style.cursor = 'progress';
      this.submitting = true;
      // verify recaptcha
      let form_data = new FormData;
      form_data.append('action', 'yodah_recaptcha_query');
      form_data.append('token', token);
      form_data.append('nonce', my_ajax_object.nonce)
      let recaptchaCheck = await axios.post(my_ajax_object.ajax_url, form_data);
      recaptchaCheck = JSON.parse(recaptchaCheck.data.data.body);
      this.$refs.recaptchaRef.reset();
      this.submitDisabled = true;
      if (recaptchaCheck.success !== true) {
        this.submitting = false;
        document.body.style.cursor = 'auto';
        console.log('reCaptcha failed...', recaptchaCheck["error-codes"][0]);
        //captcha did not pass..? dont process order - show error
        for (let i = 0; i < recaptchaCheck.error - code.length; i++) {
          this.$notify({
            type: 'error',
            duration: -1,
            text: 'There was a problem with the captcha, please try again. (Error: ' + recaptchaCheck.error - codes[i] + ')'
          })
        }
      }
      // check that there is Yodah  orderId, or create Yodah order
      // todo need to change the below as payment intent/account id
      // if(!this.orderId) {
        // if successful then we need to create order & payment intent.
        let products = this.basket.map((item) => {
          return {
            sku: item.sku,
            count: item.quantity,
            sales_price: item.itemPrice,
            description: item.desc,
          }
        });

          axios.post('https://' + this.yodahURL + '.yodah.app/api/payments/express-order/stripe',
            {
              email: this.email,
              title: this.title,
              first_name: this.firstName,
              last_name: this.lastName,
              phone: this.telMobile,
              company: this.company,
              vat: this.vat,
              products: products,
              carriage: this.basketValues.shipping,
              shipping_address: this.deliveryAddress,

              use_same_address: this.sameAddress,
              billing_address: this.billingAddress,

              amount: this.basketValues.gross,

              ecommerce_website_id: document.domain,

              order_id: this.orderId

            },
            this.headers
        ).then(response => {
          document.body.style.cursor = 'auto';
          this.$store.commit('updateOrderId', response.data.data['order_id']);
          this.$store.commit('updatePi', response.data.data['pi']);
          this.$store.commit('updatePublicKey', response.data.data['public_key']);
          this.$store.commit('updateAccountId', response.data.data['account_id']);
          // show card form
          this.gaPaymentStarted();
          this.showCardPayment();
        }).catch(error => {
          console.log('Yodah error: ', error)
          this.submitting = false;
          document.body.style.cursor = 'auto';
          this.token = null;
        })
      // }
    },
    tokenCreated (token) {
      // console.log(token);
      // handle the token
      // send it to your server
    },

    ga4CheckoutStarted() {
      gtag("event", "begin_checkout", {
        currency: "GBP",
        value: this.basketValues.gross,
        items: this.ga4Basket
      });
    },

    gaCheckoutStarted() {
      Object.keys(this.basket).forEach((item) => {
        let newItem = {
          'name' : this.basket[item].name,
          'id' : this.basket[item].sku,
          'price' : this.basket[item].itemPrice,
          'quantity' : parseInt(this.basket[item].quantity)
        }
        this.gaBasket.push(newItem);
      })
      if(window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          'event': 'checkout',
          'ecommerce': {
            'checkout': {
              'actionField': {'step': 2},
              'products': this.gaBasket
            }
          },
        })
      }
    },
      ga4PaymentStarted() {
        // removed as duplicate event, perhaps sh
          // gtag("event", "begin_checkout", {
          //   currency: "GBP",
          //   value: total,
          //   items: this.gaBasket
          // });
          // if(window.dataLayer) {
          //     dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
          //     dataLayer.push({
          //         'event': 'begin_checkout',
          //         'ecommerce': {
          //             currency: 'GBP',
          //             value: this.basketValues.gross,
          //             coupon: this.discountCode,
          //             items: this.ga4Basket
          //         }
          //     });
          // }
      },
      ga4PurchaseComplete() {
          gtag("event", "purchase", {
            transaction_id: this.orderId,
            value: this.basketValues.gross,
            tax: this.basketValues.tax,
            shipping: this.basketValues.shipping,
            coupon: this.discountCode,
            currency: "GBP",
            items: this.ga4Basket
          });
          //todo clear basket
      },
    gaPaymentStarted() {
      if(window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          'event': 'checkout',
          'ecommerce': {
            'checkout': {
              'actionField': {'step': 3},
              'products': this.gaBasket
            }
          },
        })
      }
    },

    gaPurchaseComplete() {
      if(window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          'event': 'transactionComplete',
          'ecommerce': {
            'purchase': {
              'actionField': {
                'id': this.orderId,
                'affiliation': document.URL,
                'revenue': this.basketValues.gross,
                'tax':this.basketValues.tax,
                'shipping': this.basketValues.shipping
              },
              'products': this.gaBasket
            }
          }
        });
      }


    },

    // BEGIN PayPal Logic

    // run when the paypal button is pressed
    createOrder: async function (data, actions) {
      this.submitting = false;
      this.paypalErrorMsg = '';
      let form_data = new FormData;
      form_data.append('action', 'yodah_create_pp_order');
      form_data.append('basket_values', JSON.stringify(this.basketValues));
      form_data.append('products', JSON.stringify(this.basket));
      return await axios.post(my_ajax_object.ajax_url, form_data)
          .then(response => {
            if(response.data.response.code !== 201) {
              // there was a problem;
              let body = JSON.parse(response.data.body);
              this.paypalErrorMsg = 'ERROR: ' + body.details[0].description + ' Please contact us or try another payment method.';
            }
            // console.log('success ', response);
            let data = JSON.parse(response.data.body)
            return data.id;
          });
    },

    // run when the successful PayPal response is made
    onApprove: async function (data, actions) {
      this.payPalOrderData = data;
      let form_data = new FormData;
      form_data.append('action', 'yodah_get_paypal_order_details');
      form_data.append('orderId', data.orderID);
      form_data.append('basket_values', JSON.stringify(this.basketValues));
      form_data.append('products', JSON.stringify(this.basket));      await axios.post(my_ajax_object.ajax_url, form_data)
      .then(response => {
        this.payPalOrderDetails = (response.data);
        this.localId = response.data.localId;
      })
    },

    async completePayPalOrder() {
      console.log('pp_complete_clicked');
      let result = await this.$validator.validateAll();
      console.log('validator complete');
      if(!result){
        console.log('validation error');
        return;
      }
      console.log('validation passed');
      this.submitting = true;
      let data = this.payPalOrderData
      let form_data = new FormData;
      form_data.append('action', 'yodah_capture_pp_payment');
      form_data.append('orderId', data.orderID);
      form_data.append('localId', this.localId);
      form_data.append('tel', this.telMobile)
      return axios.post(my_ajax_object.ajax_url, form_data)
          .then(response => {
            let orderData = JSON.parse(response.data);
            // console.log( "Order Result", orderData); //todo test for fail & display message, fail payment & fail on submitting order twice..
            this.paymentProvider = 'PayPal';
            // setup product for the API
            let products = this.basket.map((item) => {
              return {
                sku: item.sku,
                count: item.quantity,
                sales_price: item.itemPrice,
                description: item.desc,
              }
            });
            this.deliveryAddress.building_num = orderData.purchase_units[0].shipping.address.address_line_1;
            this.deliveryAddress.street = orderData.purchase_units[0].shipping.address.address_line_2;
            this.deliveryAddress.city = orderData.purchase_units[0].shipping.address.admin_area_2;
            this.deliveryAddress.post_code = orderData.purchase_units[0].shipping.address.postal_code;
            this.deliveryAddress.contact_name = orderData.purchase_units[0].shipping.name.full_name;
            this.deliveryAddress.contact_tel = this.telMobile;
            let form_data = new FormData;
            form_data.append('action', 'yodah_post_express_order');
            form_data.append('email', orderData.payer.email_address);
            // form_data.append('title', data.payer.title);
            form_data.append('first_name', orderData.payer.name.given_name);
            form_data.append('last_name', orderData.payer.name.surname);
            form_data.append('phone', this.telMobile);
            // form_data.append('company', this.company); I DO NOT THINK THESE ARE RETURNED?
            // form_data.append('vat', this.vat);
            form_data.append('products', JSON.stringify(products));
            form_data.append('carriage', this.basketValues.shipping);
            form_data.append('shipping_address', JSON.stringify(this.deliveryAddress));
            form_data.append('use_same_address', this.sameAddress); //todo if billing address returned need to set this to off..
            form_data.append('billing_address', JSON.stringify(this.billingAddress)); //todo if returned
            form_data.append('amount', this.basketValues.gross);
            form_data.append('basket', JSON.stringify(this.basket));
            form_data.append('basket_values', JSON.stringify(this.basketValues));
            form_data.append('domain', document.domain);
            form_data.append('transaction_id', orderData.id);
            form_data.append('transaction_data', JSON.stringify(orderData));
            form_data.append('payment_method', 'paypal');
            form_data.append('localId', this.localId);
            form_data.append('discount_code', this.discountCode);
            // todo think i need to add other discount stuff here and check all payment methods are passing discount

            axios.post(my_ajax_object.ajax_url, form_data)
                .then(response => {
                  console.log('Post order to Yodah: ', response);
                  if (response.data.response.code !== 200) {
                    // there was a problem; todo log these raw responses local log? & send noticfactions to WP Admin
                    return this.paypalErrorMsg = 'ERROR: ' + response.data.response.code + ' ' + response.data.response.message;
                  }
                  let body = JSON.parse(response.data.body);
                  this.orderId = body.data.order_id;

                  this.isPaid = true;
                  this.gaPurchaseComplete();
                  this.ga4PurchaseComplete();
                  this.$store.commit('emptyBasket');
                  let el = document.getElementById("yodahCheckout");
                  let y = el.getBoundingClientRect().top + window.pageYOffset - parseFloat(this.scrollOffset); //todo this is getting error
                  window.scrollTo({top: y, behavior: 'smooth'});
                })
                .catch(error => {
                  console.log('error: ', error);
                  this.paypalErrorMsg = 'ERROR: ' + response.data.response.code + ' ' + response.data.response.message;

                })
          });
            // When ready to go live, remove the alert and show a success message within this page. For example:
            // var element = document.getElementById('paypal-button-container');
            // element.innerHTML = '<h3>Thank you for your payment!</h3>';
            // Or go to another URL:  actions.redirect('thank_you.html');
    },

    onPayPalCancel: function (data) {
      // data just contains order id, perhaps we can look it up to get user data and save it to db to contact them..
      console.log('Paypal cancelled: ', data);
      this.paypalErrorMsg = 'PayPal cancelled by user. Please try PayPal again, or checkout with your card below.';
    },

    onPayPalError: function (err) {
      this.paypalErrorMsg = err;
    },

    loadPayPal() {
      loadScript({ "client-id": this.ppClientId,
        // "data-client-token": this.ppClientToken,
        "disable-funding": 'card',
        currency: 'GBP',
        components: 'messages,buttons',
        "enable-funding": 'paylater',
      }).then((paypal) => {
        paypal
            .Buttons({
              // Sets up the transaction when a payment button is clicked
              createOrder: this.createOrder,
              // Finalize the transaction after payer approval
              onApprove: this.onApprove,
              onCancel: this.onPayPalCancel,
              // If an error prevents buyer checkout, alert the user that an error has occurred with the buttons using the onError callback:
              onError: this.onPayPalError
            })
            .render("#paypal-button-container");
      })
    },
    registerEventListener() {
        // listen for messages from the iframe
        // need to bind methods because we are inside eventListener
        window.addEventListener('message', function(event) {
            // check that the message is trustworthy
            if (event.origin !== window.location.origin) return;
            // check that it is a purchase event
            if (!event.data.purchase) return;
            // push the data to the dataLayer to fire a tag
            window.dataLayer = window.dataLayer || [];
            this.gaPurchaseComplete.bind(this)();
            this.ga4PurchaseComplete.bind(this)();
        }.bind(this));
    }
  },
  mounted() {
    Object.keys(this.basket).forEach((item) => {
      let newGA4Item = {
        'item_id' : this.basket[item].sku,
        'item_name': this.basket[item].name,
        'price': this.basket[item].itemPrice,
        'quantity': parseInt(this.basket[item].quantity)
      }
      this.ga4Basket.push(newGA4Item);
    })
    // let iframe = document.createElement('iframe');
    // iframe.onload = () => {
    //   this.iframeLoaded = true;
    // };
    // iframe.src = 'https://secure.mite.pay360.com/hosted/SMjptVei0K_hEp7j9c7Gh7OX5/begin/SMjptVei0K_hEp7j9c7Gh7OX5';
    // iframe.id = 'cardPaymentIframe';
    // iframe.frameBorder = 0;
    // iframe.width = "100%";
    // iframe.height = 500;
    // document.getElementById("card-payment-iframe-block").appendChild(iframe);
    // fire event for GA Enhanced E-commerce
    this.gaCheckoutStarted();
    this.ga4CheckoutStarted();
    // below is required to override the Google Maps JS which turns autocomplete off
    let _this = this;
    setTimeout(function() {
      _this.$refs.deliveryAdd.$el.setAttribute('autocomplete', 'street-address');
    }, 1000);

    // if paypal client Id has been set then load paypal buttons
    if(this.ppClientId) {
      this.loadPayPal(this.basketValues.gross);
    }

    // this.recaptchaSiteKey = jQuery('#recaptcha').val();
    // for ga tracking once purchase is complete
    // todo could prob use this method to remove iframe on complete/fail and use standard vue stuff
    this.registerEventListener();
  },
  watch: {

  },

};
</script>

<style>
.iframe-close{
  cursor: pointer;
}
</style>
